import React from 'react';
import {FormattedMessage} from 'react-intl';
import {string, bool, func, object} from 'prop-types';
import BasicModal from 'components/common/BasicModal';
import {basicForm} from 'utils/helpers';
import config from './changePasswordFormConfig';

const ChangePasswordForm = basicForm(config);

const ChangePasswordModal = props => (
  <BasicModal
    header={<FormattedMessage id='userManagement.userDetail.modals.changePassword.header' values={{email: props.email}} />}
    specialType='primary-modal db-create-break-modal fadeInUp animResponse'
    dimmer='inverted'
    modalSize='small'
    actions={[
      {
        label: <FormattedMessage id='userManagement.userDetail.modals.changePassword.cancel' />,
        action: props.handleClose,
        isDisabled: props.changingPassword,
        displayType: 'menu-item'
      },
      {
        label: <FormattedMessage id='userManagement.userDetail.modals.changePassword.submit' />,
        action: props.submit,
        loading: props.changingPassword,
        isDisabled: props.hasErrors || false,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    open={props.modalOpen}
    onClose={props.handleClose}>
    <ChangePasswordForm
      onValueChanged={props.onValueChanged}
      onValidationError={props.onValidationError}
      errors={props.errors}
      data={props.formData} />
  </BasicModal>
);

ChangePasswordModal.propTypes = {
  formData: object.isRequired,
  submit: func.isRequired,
  onValueChanged: func.isRequired,
  onValidationError: func,
  hasErrors: bool,
  handleClose: func.isRequired,
  email: string,
  modalOpen: bool.isRequired,
  changingPassword: bool
};

export default ChangePasswordModal;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/ChangePasswordModal/ChangePasswordModal.jsx